import { useState } from 'react';

import {
  isValidEmail,
  shareRenderingWithEmail,
  useConfiguredToast,
} from 'src/modules/renderings/components/ShareModal/shareHelpers';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { logError } from 'src/shared/telemetry/logger';

const useShareByEmail = () => {
  const [shareEmail, setShareEmail] = useState('');
  const [showEmailError, setShowEmailError] = useState(false);
  const [isEmailShareLoading, setIsEmailShareLoading] = useState(false);
  const t = useTranslate(TranslationNamespace.SHARED);
  const toast = useConfiguredToast();

  const handleShareByEmail = async (shareToken: string) => {
    try {
      setIsEmailShareLoading(true);
      if (isValidEmail(shareEmail)) {
        await shareRenderingWithEmail({ email: shareEmail, shareToken });
        toast({
          description: t('renderings.messages.emailShare.success', {
            email: shareEmail,
          }),
          status: 'success',
        });
        setShareEmail('');
      } else {
        setShowEmailError(true);
        setIsEmailShareLoading(false);
      }
    } catch (error) {
      logError(error as Error);
    } finally {
      setIsEmailShareLoading(false);
    }
  };

  return {
    isEmailShareLoading,
    shareEmail,
    setShareEmail,
    setShowEmailError,
    handleShareByEmail,
    showEmailError,
  };
};

export { useShareByEmail };
